import { FC } from 'react'
import { Link, useNavigate } from 'react-router-dom'

import { Avatar, AvatarFallback, AvatarImage } from 'shared/components/ui/avatar'
import { Button } from 'shared/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from 'shared/components/ui/dropdown-menu'

import { useAuthStore } from './auth-store'
import { getUserInitials } from './utils'

export const PlayerMenu: FC = () => {
  const navigate = useNavigate()
  const logout = useAuthStore(state => state.logout)
  const user = useAuthStore(state => state.user)
  const player = useAuthStore(state => state.player)
  const avatar = player?.avatar ?? user?.photoURL ?? undefined

  return user ? (
    <DropdownMenu>
      <DropdownMenuTrigger className="text-md flex cursor-pointer items-center gap-2 text-white md:absolute md:right-0 md:top-0">
        <Avatar>
          <AvatarImage src={avatar} />
          <AvatarFallback>{getUserInitials(user.displayName)}</AvatarFallback>
        </Avatar>
        {player?.nickname || user.displayName}
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem asChild>
          <Link to="/player">Profile</Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/stats">Statistics</Link>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={logout}>Log out</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  ) : (
    <Button variant={'ghost'} className="text-white" onClick={() => navigate('/login')}>
      Login
    </Button>
  )
}
